import React from "react";
import { cn } from "../../utils/lib";

export function StopwatchIcon({ className, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn("", className)}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 4.65002C7.21996 4.65002 3.32996 8.54002 3.32996 13.32C3.32996 18.1 7.21996 22 12 22C16.78 22 20.67 18.11 20.67 13.33C20.67 8.55002 16.78 4.65002 12 4.65002ZM12.75 13C12.75 13.41 12.41 13.75 12 13.75C11.59 13.75 11.25 13.41 11.25 13V8.00002C11.25 7.59002 11.59 7.25002 12 7.25002C12.41 7.25002 12.75 7.59002 12.75 8.00002V13Z"
        fill="white"
        fill-opacity="0.5"
      />
      <path
        d="M14.89 3.45H9.11001C8.71001 3.45 8.39001 3.13 8.39001 2.73C8.39001 2.33 8.71001 2 9.11001 2H14.89C15.29 2 15.61 2.32 15.61 2.72C15.61 3.12 15.29 3.45 14.89 3.45Z"
        fill="white"
        fill-opacity="0.5"
      />
    </svg>
  );
}
